import { constants } from "../../../constants";

export default class RequestFullScreen {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        if (this.gb.settings && this.gb.settings.fullScreenMode) {
            this.gb.emitters.emit.web.requestFullScreen();
        } else {
            logger.debug(`setting fullScreenMode is not setup in aggregator`);
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.STAKELOGIC2:
                event['FULLSCREEN_MODE_ON'] = this._default;
                break;
            case constants.KAJ:
                event['game.fullscreen.enter'] = this._default;
                break;
            default:
                event['fullScreen'] = this._default;
        }

        return event;
    }
}
